import { createStyles, makeStyles, Theme } from "@material-ui/core";
import gear from "../../media/gear_1.svg";
import styles from "../loading.module.css";

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		logoNameContainer: {
			whiteSpace: "nowrap",
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
			marginLeft: "40px",
		},
		nameTop: {
			marginLeft: "10px",
			marginRight: "10px",
			fontSize: "20px",
			marginTop: "10px",
			color: "white",
			fontFamily: "Roboto,Arial,Helvetica,sans-serif",
		},
		nameBottom: {
			color: "rgba(255,255,255,0.9)",
			fontSize: "25px",
			width: "0px",
			whiteSpace: "nowrap",
			marginTop: "20px",
			marginLeft: "30px",
		},

		gear: {
			width: "35px",
		},
		line: {
			borderLeft: "2px solid rgb(208, 208, 208)",
			height: "40px",
		},
	});
});

export const LogoName = () => {
	const classes = useStyles();
	return (
		<div className={classes.logoNameContainer}>
			<img src={gear} className={styles.rotate}></img>

			<h2 className={classes.nameBottom}>Loading the dashboard...</h2>
		</div>
	);
};

export const LogoName2 = () => {
	const classes = useStyles();
	return (
		<div className={classes.logoNameContainer}>
			<img src={gear} className={styles.rotate}></img>

			<h2 className={classes.nameBottom}>Saving your Dashboard...</h2>
		</div>
	);
};

export default LogoName;
